import React, { useState, useEffect } from 'react';
import NotificationService from '../Services/NotificationService';
import ErrorMessage from './ErrorMessage';

// Nav indicator only (dot / number). The new-message popup + background-process
// popups live in NotificationTriggers.tsx (CD-5276); this component no longer
// uses the props.message / ErrorMessage.SetIcon path.
export default function NumberOfUnreadMessages({ showNumber = false, notificationsWithoutNumberDropDown = false }) {
  const [result, setResult] = useState(0);

  useEffect(() => {
    let timer = null;
    let cancelled = false;
    const poll = () => {
      NotificationService.GetNumberOfUnreadMessages()
        .then((r) => {
          if (cancelled) return;
          setResult(r.result);
          if (ErrorMessage.NotDev()) timer = window.setTimeout(poll, 60000);
        })
        .catch(() => { if (!cancelled) timer = window.setTimeout(poll, 600000); });
    };
    poll();
    return () => { cancelled = true; if (timer) window.clearTimeout(timer); };
  }, []);

  if (result === 0) return null;
  if (showNumber === true) return <span className='badge'>{result}</span>;
  if (notificationsWithoutNumberDropDown === true) return <span className='notificationsWithoutNumberDropDown' />;
  return <span className='notificationsWithoutNumber' />;
}
